import React from 'react';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';
import { useTranslation } from '@lyearn/i18n';
import { Trans } from '@lyearn/i18n';
import { EmailOutline } from '@lyearn/icons';
import ArchiveHeadline from '@/modules/corporate/components/ArchiveHeadline';
import { LearnerWidgetProps } from '@/modules/learner/views/LearnerProfile/types';
import { UserStatusEnum } from '@/types/schema';

type Props = Pick<LearnerWidgetProps, 'learner'>;

const LearnerProfileBanner = (props: Props) => {
  const { learner } = props;
  const { t } = useTranslation();

  switch (learner.status) {
    case UserStatusEnum.Archived: {
      return (
        <ArchiveHeadline
          isArchived
          text={
            learner.deletedAt ? (
              <Trans
                as="span"
                color="text-text-secondary"
                i18nKey="Admin:LearnerAndGroups.ArchiveHeadlineSince"
                values={{ date: formatDateWithYear(learner.deletedAt, DateFormat.Date) }}
              />
            ) : (
              t('Admin:LearnerAndGroups.ArchiveHeadline')
            )
          }
        />
      );
    }

    case UserStatusEnum.Invited: {
      return (
        <ArchiveHeadline
          isArchived
          Icon={EmailOutline}
          text={
            <Trans
              as="span"
              color="text-text-secondary"
              i18nKey="LearnerProfile:PendingInviteSince"
              values={{ date: formatDateWithYear(learner.createdAt, DateFormat.Date) }}
            />
          }
        />
      );
    }

    default: {
      return null;
    }
  }
};

export default LearnerProfileBanner;
